import React, { Component } from "react";
import domain from "../../../../../domain.js";

import axios from "axios";
import { Table } from "semantic-ui-react";
import { Form, Checkbox } from "semantic-ui-react";
import { Message } from "semantic-ui-react";
// import { Header } from 'semantic-ui-react'
import { TextArea } from "semantic-ui-react";
import { Button } from "semantic-ui-react";
import moment from "moment";
// const colors = [
//   'red',
//   'orange',
//   'yellow',
//   'olive',
//   'green',
//   'teal',
//   'blue',
//   'violet',
//   'purple',
//   'pink',
//   'brown',
//   'grey',
//   'black',
// ]
const colors = ["violet"];
let flag = false;
export default class OverallFeedback extends Component {
  constructor(props) {
    super(props);
    this.state = {
      feedback: {
        clarity: "5",
        objective: "5",
        learning: "5",
        faculty: "5",
        demonstration: "5",
        coursematerial: "5",
        overall: "5",
        comment: "",
      },
      loading: true,
      error: "",
      data: null,

      course_id: "",
      trainee_id: "",
      trainee_name: "",
      submit: false,
      typeofSubmit: "save",
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleChangeo = this.handleChangeo.bind(this);
    this.handleChangel = this.handleChangel.bind(this);
    this.handleChangef = this.handleChangef.bind(this);
    this.handleChangd = this.handleChanged.bind(this);
    this.handleChangec = this.handleChangec.bind(this);
    this.handleChangeol = this.handleChangeol.bind(this);
    this.handleChangecomment = this.handleChangecomment.bind(this);
    setTimeout(() => {
      this.setState({ submit: true });
    }, 20000);
  }
  checkFeedbackAvailability = () => {
    const traineeId = this.props.match.params.id;
    axios
      .request({
        method: "get",
        url: `${domain.DBServer}/check-course-feedback/${traineeId}`,
      })
      .then((result) => {
        if (result.data.success) {
          let feedback = { ...this.state.feedback };
          feedback.clarity = result.data.result[0].feedback.clarity;
          feedback.objective = result.data.result[0].feedback.objective;
          feedback.comment = result.data.result[0].feedback.comment;
          feedback.learning = result.data.result[0].feedback.learning;
          feedback.faculty = result.data.result[0].feedback.faculty;
          feedback.demonstration = result.data.result[0].feedback.demonstration;
          feedback.coursematerial =
            result.data.result[0].feedback.coursematerial;
          feedback.overall = result.data.result[0].feedback.overall;

          this.setState({
            feedback,
          });
          flag = true;
        } else {
          flag = false;
        }
      })
      .catch((error) => console.log(error));
  };

  handleChangecomment = (e, { value }) => {
    let feedback = { ...this.state.feedback };
    feedback.comment = value;
    this.setState({
      feedback,
    });
  };

  handleChange = (e, { value }) => {
    e.preventDefault();
    let feedback = { ...this.state.feedback };
    feedback.clarity = value;

    this.setState({
      feedback,
    });
  };
  handleChangeo = (e, { value }) => {
    e.preventDefault();
    let feedback = { ...this.state.feedback };
    feedback.objective = value;

    this.setState({
      feedback,
    });
  };
  handleChangel = (e, { value }) => {
    e.preventDefault();
    let feedback = { ...this.state.feedback };
    feedback.learning = value;
    this.setState({
      feedback,
    });
  };
  handleChangef = (e, { value }) => {
    e.preventDefault();
    let feedback = { ...this.state.feedback };
    feedback.faculty = value;
    this.setState({
      feedback,
    });
  };
  handleChanged = (e, { value }) => {
    e.preventDefault();
    let feedback = { ...this.state.feedback };
    feedback.demonstration = value;
    this.setState({
      feedback,
    });
  };
  handleChangec = (e, { value }) => {
    e.preventDefault();
    let feedback = { ...this.state.feedback };
    feedback.coursematerial = value;
    this.setState({
      feedback,
    });
  };
  handleChangeol = (e, { value }) => {
    e.preventDefault();
    let feedback = { ...this.state.feedback };
    feedback.overall = value;
    this.setState({
      feedback,
    });
  };

  saveFeedback(feedback) {
    console.log("saving to databasae");
    console.log(feedback);
    axios
      .request({
        method: "post",
        url: `${domain.DBServer}/save-course-feedback`,
        data: feedback,
      })
      .then((result) => {
        if (result.data.success) alert(result.data.msg);
      })
      .catch((error) => console.log(error));
  }
  updateFeedback(feedback) {
    console.log("saving to databasae");
    console.log(feedback);
    axios
      .request({
        method: "PUT",
        url: `${domain.DBServer}/update-course-feedback`,
        data: feedback,
      })
      .then((result) => {
        if (result.data.success) alert(result.data.msg);
      })
      .catch((error) => console.log(error));
  }

  onSubmit = (e) => {
    e.preventDefault();
    const feedback_with_courseid = {
      feedback: {
        clarity: this.state.feedback.clarity,
        objective: this.state.feedback.objective,
        learning: this.state.feedback.learning,
        faculty: this.state.feedback.faculty,
        demonstration: this.state.feedback.demonstration,
        coursematerial: this.state.feedback.coursematerial,
        overall: this.state.feedback.overall,
        comment: this.state.feedback.comment,
      },
      course_id: this.state.course_id,
      trainee_id: this.state.trainee_id,
    };
    console.log(this.state.typeofSubmit);
    if (this.state.typeofSubmit === "save") {
      if (flag) {
        this.updateFeedback(feedback_with_courseid);
      } else {
        this.saveFeedback(feedback_with_courseid);
      }
    }
    //  else if(this.state.typeofSubmit==='saveandcontinue')
    //  {

    //           const finalfeedback=JSON.parse(JSON.stringify(localStorage.getItem("feedback")))
    //           console.log(finalfeedback)
    //           this.saveFeedback()
    //  }
  };
  save = (e) => {
    this.setState({
      typeofSubmit: "save",
    });
  };
  //  saveAndContinue=(e)=>
  //  {
  //   this.setState(
  //     {
  //       typeofSubmit:'saveandcontinue'
  //     }
  //   )
  //  }

  fetchCourseByTraineeId() {
    console.log("here");
    const traineeId = this.props.match.params.id;

    axios
      .get(`${domain.DBServer}/fetch-course-trainee/${traineeId}`)
      .then((result) => {
        // console.log(result);
        this.setState({
          data: result.data[0],
          course_id: result.data[0].course_id,
          trainee_id: result.data[0].trainee_id,
          trainee_name: result.data[0].name,
          loading: false,
          error: false,
        });
      })
      .catch((error) => {
        console.error("error: ", error);
        this.setState({
          error: `${error}`,
          loading: false,
        });
      });
  }

  componentDidMount() {
    this.fetchCourseByTraineeId();
    this.checkFeedbackAvailability();
  }

  render() {
    const { loading, error } = this.state;
    if (loading) {
      return <p>Loading ...</p>;
    }
    if (error) {
      return (
        <p>
          There was an error loading the courses.{" "}
          <button onClick={this.loadData}>Try again</button>
        </p>
      );
    }
    // console.log(this.state.feedback.clarity)
    return (
      <div>
        <Message
          attached
          header="Welcome to NRSC!"
          content="Fill out the form below to submit overall feedback"
          size="small"
          color="violet"
        />
        <Form
          className="attached fluid segment"
          onSubmit={this.onSubmit}
          disabled={!this.state.submit}
        >
          <h2 style={{ textAlign: "center", color: "#3f51b5" }}>
            Feedback Proforma
          </h2>

          <h3 style={{ textAlign: "center", color: "#3f51b5" }}>
            {" "}
            Course Title: {this.state.data.title}
          </h3>
          <h3 style={{ textAlign: "center", color: "#3f51b5" }}>
            {moment(this.state.data.start_date).format("LL")} To{" "}
            {moment(this.state.data.end_date).format("LL")}{" "}
          </h3>
          {/* <h5 style={{textAlign:"center",color:"blue"}}>  </h5>         */}
          <p> Name : {this.state.trainee_name} </p>

          <p> Rate the following in the scale of 1 to 5 </p>
          <p style={{ textAlign: "right" }}>
            (5- Excellent, 4- VeryGood, 3- Good, 2- Just Fair, 1- Poor)
          </p>

          {colors.map((color) => (
            <Table color={color} key={color}>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell></Table.HeaderCell>
                  <Table.HeaderCell>5</Table.HeaderCell>
                  <Table.HeaderCell>4</Table.HeaderCell>
                  <Table.HeaderCell>3</Table.HeaderCell>
                  <Table.HeaderCell>2</Table.HeaderCell>
                  <Table.HeaderCell>1</Table.HeaderCell>
                </Table.Row>
              </Table.Header>

              <Table.Body>
                <Table.Row>
                  <Table.Cell>Clarity of Course Objective</Table.Cell>
                  <Table.Cell>
                    <Form.Field>
                      <Checkbox
                        radio
                        name="clarity"
                        value="5"
                        checked={this.state.feedback.clarity === "5"}
                        onChange={this.handleChange}
                      />
                    </Form.Field>
                  </Table.Cell>
                  <Table.Cell>
                    <Form.Field>
                      <Checkbox
                        radio
                        name="clarity"
                        value="4"
                        checked={this.state.feedback.clarity === "4"}
                        onChange={this.handleChange}
                      />
                    </Form.Field>
                  </Table.Cell>
                  <Table.Cell>
                    <Form.Field>
                      <Checkbox
                        radio
                        name="clarity"
                        value="3"
                        checked={this.state.feedback.clarity === "3"}
                        onChange={this.handleChange}
                      />
                    </Form.Field>
                  </Table.Cell>
                  <Table.Cell>
                    <Form.Field>
                      <Checkbox
                        radio
                        name="clarity"
                        value="2"
                        checked={this.state.feedback.clarity === "2"}
                        onChange={this.handleChange}
                      />
                    </Form.Field>
                  </Table.Cell>
                  <Table.Cell>
                    <Form.Field>
                      <Checkbox
                        radio
                        name="clarity"
                        value="1"
                        checked={this.state.feedback.clarity === "1"}
                        onChange={this.handleChange}
                      />
                    </Form.Field>
                  </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Whether Objective met</Table.Cell>
                  <Table.Cell>
                    <Form.Field>
                      <Checkbox
                        radio
                        name="objective"
                        value="5"
                        checked={this.state.feedback.objective === "5"}
                        onChange={this.handleChangeo}
                      />
                    </Form.Field>
                  </Table.Cell>
                  <Table.Cell>
                    <Form.Field>
                      <Checkbox
                        radio
                        name="objective"
                        value="4"
                        checked={this.state.feedback.objective === "4"}
                        onChange={this.handleChangeo}
                      />
                    </Form.Field>
                  </Table.Cell>
                  <Table.Cell>
                    <Form.Field>
                      <Checkbox
                        radio
                        name="objective"
                        value="3"
                        checked={this.state.feedback.objective === "3"}
                        onChange={this.handleChangeo}
                      />
                    </Form.Field>
                  </Table.Cell>
                  <Table.Cell>
                    <Form.Field>
                      <Checkbox
                        radio
                        name="objective"
                        value="2"
                        checked={this.state.feedback.objective === "2"}
                        onChange={this.handleChangeo}
                      />
                    </Form.Field>
                  </Table.Cell>
                  <Table.Cell>
                    <Form.Field>
                      <Checkbox
                        radio
                        name="objective"
                        value="1"
                        checked={this.state.feedback.objective === "1"}
                        onChange={this.handleChangeo}
                      />
                    </Form.Field>
                  </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Learning New Concepts</Table.Cell>
                  <Table.Cell>
                    <Form.Field>
                      <Checkbox
                        radio
                        name="learning"
                        value="5"
                        checked={this.state.feedback.learning === "5"}
                        onChange={this.handleChangel}
                      />
                    </Form.Field>
                  </Table.Cell>
                  <Table.Cell>
                    <Form.Field>
                      <Checkbox
                        radio
                        name="learning"
                        value="4"
                        checked={this.state.feedback.learning === "4"}
                        onChange={this.handleChangel}
                      />
                    </Form.Field>
                  </Table.Cell>
                  <Table.Cell>
                    <Form.Field>
                      <Checkbox
                        radio
                        name="learning"
                        value="3"
                        checked={this.state.feedback.learning === "3"}
                        onChange={this.handleChangel}
                      />
                    </Form.Field>
                  </Table.Cell>
                  <Table.Cell>
                    <Form.Field>
                      <Checkbox
                        radio
                        name="learning"
                        value="2"
                        checked={this.state.feedback.learning === "2"}
                        onChange={this.handleChangel}
                      />
                    </Form.Field>
                  </Table.Cell>
                  <Table.Cell>
                    <Form.Field>
                      <Checkbox
                        radio
                        name="learning"
                        value="1"
                        checked={this.state.feedback.learning === "1"}
                        onChange={this.handleChangel}
                      />
                    </Form.Field>
                  </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Faculty Presentation Skills</Table.Cell>
                  <Table.Cell>
                    <Form.Field>
                      <Checkbox
                        radio
                        name="faculty"
                        value="5"
                        checked={this.state.feedback.faculty === "5"}
                        onChange={this.handleChangef}
                      />
                    </Form.Field>
                  </Table.Cell>
                  <Table.Cell>
                    <Form.Field>
                      <Checkbox
                        radio
                        name="faculty"
                        value="4"
                        checked={this.state.feedback.faculty === "4"}
                        onChange={this.handleChangef}
                      />
                    </Form.Field>
                  </Table.Cell>
                  <Table.Cell>
                    <Form.Field>
                      <Checkbox
                        radio
                        name="faculty"
                        value="3"
                        checked={this.state.feedback.faculty === "3"}
                        onChange={this.handleChangef}
                      />
                    </Form.Field>
                  </Table.Cell>
                  <Table.Cell>
                    <Form.Field>
                      <Checkbox
                        radio
                        name="faculty"
                        value="2"
                        checked={this.state.feedback.faculty === "2"}
                        onChange={this.handleChangef}
                      />
                    </Form.Field>
                  </Table.Cell>
                  <Table.Cell>
                    <Form.Field>
                      <Checkbox
                        radio
                        name="faculty"
                        value="1"
                        checked={this.state.feedback.faculty === "1"}
                        onChange={this.handleChangef}
                      />
                    </Form.Field>
                  </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Usefulness of Demonstration</Table.Cell>
                  <Table.Cell>
                    <Form.Field>
                      <Checkbox
                        radio
                        name="demonstration"
                        value="5"
                        checked={this.state.feedback.demonstration === "5"}
                        onChange={this.handleChanged}
                      />
                    </Form.Field>
                  </Table.Cell>
                  <Table.Cell>
                    <Form.Field>
                      <Checkbox
                        radio
                        name="demonstration"
                        value="4"
                        checked={this.state.feedback.demonstration === "4"}
                        onChange={this.handleChanged}
                      />
                    </Form.Field>
                  </Table.Cell>
                  <Table.Cell>
                    <Form.Field>
                      <Checkbox
                        radio
                        name="demonstration"
                        value="3"
                        checked={this.state.feedback.demonstration === "3"}
                        onChange={this.handleChanged}
                      />
                    </Form.Field>
                  </Table.Cell>
                  <Table.Cell>
                    <Form.Field>
                      <Checkbox
                        radio
                        name="demonstration"
                        value="2"
                        checked={this.state.feedback.demonstration === "2"}
                        onChange={this.handleChanged}
                      />
                    </Form.Field>
                  </Table.Cell>
                  <Table.Cell>
                    <Form.Field>
                      <Checkbox
                        radio
                        name="demonstration"
                        value="1"
                        checked={this.state.feedback.demonstration === "1"}
                        onChange={this.handleChanged}
                      />
                    </Form.Field>
                  </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Usefulness of Course Material</Table.Cell>
                  <Table.Cell>
                    <Form.Field>
                      <Checkbox
                        radio
                        name="coursematerial"
                        value="5"
                        checked={this.state.feedback.coursematerial === "5"}
                        onChange={this.handleChangec}
                      />
                    </Form.Field>
                  </Table.Cell>
                  <Table.Cell>
                    <Form.Field>
                      <Checkbox
                        radio
                        name="coursematerial"
                        value="4"
                        checked={this.state.feedback.coursematerial === "4"}
                        onChange={this.handleChangec}
                      />
                    </Form.Field>
                  </Table.Cell>
                  <Table.Cell>
                    <Form.Field>
                      <Checkbox
                        radio
                        name="coursematerial"
                        value="3"
                        checked={this.state.feedback.coursematerial === "3"}
                        onChange={this.handleChangec}
                      />
                    </Form.Field>
                  </Table.Cell>
                  <Table.Cell>
                    <Form.Field>
                      <Checkbox
                        radio
                        name="coursematerial"
                        value="2"
                        checked={this.state.feedback.coursematerial === "2"}
                        onChange={this.handleChangec}
                      />
                    </Form.Field>
                  </Table.Cell>
                  <Table.Cell>
                    <Form.Field>
                      <Checkbox
                        radio
                        name="coursematerial"
                        value="1"
                        checked={this.state.feedback.coursematerial === "1"}
                        onChange={this.handleChangec}
                      />
                    </Form.Field>
                  </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Overall Course evaluation</Table.Cell>
                  <Table.Cell>
                    <Form.Field>
                      <Checkbox
                        radio
                        name="overall"
                        value="5"
                        checked={this.state.feedback.overall === "5"}
                        onChange={this.handleChangeol}
                      />
                    </Form.Field>
                  </Table.Cell>
                  <Table.Cell>
                    <Form.Field>
                      <Checkbox
                        radio
                        name="overall"
                        value="4"
                        checked={this.state.feedback.overall === "4"}
                        onChange={this.handleChangeol}
                      />
                    </Form.Field>
                  </Table.Cell>
                  <Table.Cell>
                    <Form.Field>
                      <Checkbox
                        radio
                        name="overall"
                        value="3"
                        checked={this.state.feedback.overall === "3"}
                        onChange={this.handleChangeol}
                      />
                    </Form.Field>
                  </Table.Cell>
                  <Table.Cell>
                    <Form.Field>
                      <Checkbox
                        radio
                        name="overall"
                        value="2"
                        checked={this.state.feedback.overall === "2"}
                        onChange={this.handleChangeol}
                      />
                    </Form.Field>
                  </Table.Cell>
                  <Table.Cell>
                    <Form.Field>
                      <Checkbox
                        radio
                        name="overall"
                        value="1"
                        checked={this.state.feedback.overall === "1"}
                        onChange={this.handleChangeol}
                      />
                    </Form.Field>
                  </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>
                    <TextArea
                      autoheight="true"
                      placeholder="Any other Comments"
                      name="comment"
                      value={this.state.feedback.comment}
                      onChange={this.handleChangecomment}
                    />
                  </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>
                    <Button type="submit" onClick={this.save}>
                      Save & Submit
                    </Button>
                    {/* <Button type='submit' disabled onClick={this.saveAndContinue}>Save & Submit</Button> */}
                  </Table.Cell>
                </Table.Row>
              </Table.Body>
            </Table>
          ))}
        </Form>
      </div>
    );
  }
}
